export const isMobile = () => {
  return window.matchMedia("(max-width: 767px)").matches
}
export const isDesktop = () => {
  return window.matchMedia("(min-width: 1024px)").matches
}

export const getViewPortWidth = () => {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

export const getViewPortHeight = () => {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
}
